export const nestedStructureTranslation = {
  buttons: {
    collapseAll: 'Collapse All',
    expandAll: 'Expand All',
  },
  children: 'Subordinate employees',
  currentStructure: {
    organizational: 'Current Organizational Structure',
    personal: 'Current Personal Structure',
  },
  emptyState: {
    noData: 'No Structure Data',
    noDataDescription: 'Check if data is available for the selected simulation.',
    selectDescription: 'Go to the "Manage Structures" tab to display and select a structure.',
    selectStructure: 'Select Structure',
  },
  goToProfile: 'Go to Profile',
  hierarchy: 'Hierarchy',
  loading: 'Loading structure...',
  noHierarchyInfo: 'No hierarchy information available',
  search: {
    label: 'Search:',
    placeholder: 'Search...',
  },
  statistics: {
    expandedNodes: 'Expanded nodes:',
    totalUnits: 'Total number of units:',
  },
  structureType: {
    organizational: 'Organizational',
    personal: 'Personnel',
  },
  subunits: 'subunits',
  title: 'Nested Structure',
  total: 'total',
  type: 'Type',
  unitName: 'Unit Name',
  vacancy: 'VACANCY',
  viewMode: {
    cards: 'Full',
    tree: 'Compact',
  },
};
